import mitt from 'mitt';

// eslint-disable-next-line no-shadow
export enum NOTIFICATION {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  INFO = 'INFO',
}

interface NotificationEvent {
  message: string;
  showNotification?: boolean;
  permanent?: boolean;
}

type Handler = (event: NotificationEvent) => void;

interface Emitter {
  emit(type: NOTIFICATION, event: NotificationEvent): void;

  emit(type: NOTIFICATION): void;

  on(type: NOTIFICATION, handler: Handler): void;
}

const Bus: Emitter = mitt();

export default Bus;
